import { useRef, useEffect, useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import config from '../config';

export default function ReCaptcha() {
  const ref = useRef(null);
  const { setCaptcha } = useContext(UserContext);
  const widgetIdRef = useRef(null);

  const renderCaptcha = () => {
    if (window.grecaptcha && window.grecaptcha.render && ref.current) {
      // Eğer daha önce render edilmişse, reset yap
      if (widgetIdRef.current !== null) {
        try {
          window.grecaptcha.reset(widgetIdRef.current);
        } catch (e) {
          console.error('reCAPTCHA reset error:', e);
        }
      } else {
        // İlk defa render ediyoruz
        try {
          widgetIdRef.current = window.grecaptcha.render(ref.current, {
            sitekey: config.sitekey,
            callback: (token) => {
              // Token'ı localStorage'a kaydet
              localStorage.setItem('captcha_token', token);
              setCaptcha(true); // Captcha çözüldü olarak işaretle
              console.log('reCAPTCHA başarıyla doğrulandı');
            },
            'expired-callback': () => {
              console.log('reCAPTCHA süresi doldu');
              setCaptcha(false);
              localStorage.removeItem('captcha_token');
            },
            'error-callback': () => {
              console.error('reCAPTCHA doğrulama hatası');
              setCaptcha(false);
              localStorage.removeItem('captcha_token');
            }
          });
        } catch (e) {
          console.error('reCAPTCHA render error:', e);
        }
      }
    }
  };

  useEffect(() => {
    // Script zaten yüklü mü kontrol et
    if (window.grecaptcha && window.grecaptcha.render) {
      renderCaptcha();
    } else if (!document.getElementById('recaptcha-script')) {
      // Script'i yükle
      const script = document.createElement('script');
      script.id = 'recaptcha-script';
      script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';
      script.async = true;
      script.defer = true;
      
      // Global callback fonksiyonu
      window.onRecaptchaLoad = () => {
        console.log('reCAPTCHA script yüklendi');
        renderCaptcha();
      };

      script.onerror = () => {
        console.error('reCAPTCHA script yüklenemedi');
      };

      document.body.appendChild(script);
    }

    // Reset fonksiyonunu global olarak erişilebilir yap
    window.resetCaptcha = resetCaptcha;

    return () => {
      // Cleanup
      if (widgetIdRef.current !== null && window.grecaptcha) {
        try {
          window.grecaptcha.reset(widgetIdRef.current);
        } catch (e) {
          console.error('Cleanup error:', e);
        }
      }
      delete window.resetCaptcha;
      delete window.onRecaptchaLoad;
    };
    // eslint-disable-next-line
  }, []);

  const resetCaptcha = () => {
    if (widgetIdRef.current !== null && window.grecaptcha) {
      try {
        window.grecaptcha.reset(widgetIdRef.current);
      } catch (e) {
        console.error('Reset error:', e);
      }
    }
    setCaptcha(false);
    localStorage.removeItem('captcha_token');
  };

  return (
    <div 
      ref={ref} 
      style={{ 
        marginTop: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }} 
    />
  );
}
